import { Box, FormField, TextInput } from "grommet"
import SidebarSection from "../../../layout/SidebarSection"
import { Checkbox, Gallery } from "grommet-icons"
import Pointer from "../../pointers/Pointer"
import RouletteBackgroundSettings from "../RouletteBackgroundSettings"
import { FormTypeContext } from "./RouletteItemDesignTab"
import RouletteFrameSettings from "../RouletteFrameSettings"
import RoulettePinSettings from "../RoulettePinSettings"
import RangeInputWithEdit from "../../../../forms/RangeInputWithEdit"

const navs = [
    { label: 'roulette:backgroundTitle', icon: <Gallery/>, component: <RouletteBackgroundSettings /> },
    { label: 'roulette:borderTitle', icon: <Checkbox/>, component: <RouletteFrameSettings /> },
    { label: 'roulette:pinTitle', icon: <Pointer style={{ width: '18px', height: '18px', fill: '#FFFFFF' }}/>, component: <RoulettePinSettings /> },
]

const RouletteDesignTab = () => {

    return (
        <Box>
            <SidebarSection navs={navs} fill/>
        </Box>
    )
}

export default RouletteDesignTab;